import { CoreMenu } from '@core/types';
import { Role } from 'app/auth/models';

export const menu: CoreMenu[] = [
  {
    id: 'center',
    title: 'Centro',
    type: 'item',
    icon: 'home',
    url: 'pages/app/center',
  },
  {
    id: 'devices',
    title: 'Dispositivos',
    type: 'item',
    icon: 'smartphone',
    url: 'pages/app/users-devices',
    role: [Role.Developer],
  },
  {
    id: 'diccionario',
    title: 'Diccionario',
    type: 'section',
    icon: 'book',
    role: [Role.Developer, Role.Coordinator, Role.Employee],
    children: [
      {
        id: 'businessLine',
        title: 'Giros comerciales',
        type: 'item',
        url: 'pages/app/dictionary/business-lines',
        icon: 'settings',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
      },
      {
        id: 'jobPosition',
        title: 'Puestos de trabajo',
        type: 'item',
        url: 'pages/app/dictionary/job-positions',
        icon: 'tool',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
      },
    ],
  },
  {
    id: 'reports',
    title: 'Reportes',
    type: 'section',
    icon: 'file',
    role: [Role.Developer, Role.Manager, Role.Coordinator, Role.Client],
    children: [
      {
        id: 'reportFiles',
        title: 'Búsqueda/Descarga',
        type: 'item',
        icon: 'download-cloud',
        url: 'pages/app/reports/files',
        role: [Role.Developer, Role.Manager, Role.Coordinator, Role.Client],
      },
      {
        id: 'graph',
        title: 'Gráfico',
        type: 'item',
        icon: 'bar-chart-2',
        url: 'pages/app/reports/charts',
        role: [Role.Developer, Role.Manager, Role.Coordinator, Role.Client],
      },
      {
        id: 'credentialsDueReturn',
        title: 'ID\'s Debidas',
        type: 'item',
        icon: 'credit-card',
        url: 'pages/app/reports/credentials-due-return',
        role: [Role.Developer, Role.Manager, Role.Coordinator],
      },
    ],
  },
  {
    id: 'companies',
    title: 'Compañías',
    type: 'section',
    icon: 'globe',
    children: [
      {
        id: 'list',
        title: 'Listado',
        type: 'item',
        url: 'pages/app/company/list',
        icon: 'list',
      },
      {
        id: 'new',
        title: 'Nuevo registro',
        type: 'item',
        url: 'pages/app/company/new',
        icon: 'plus',
        role: [Role.Developer, Role.Coordinator],
      },
    ],
  },
  {
    id: 'workers',
    title: 'Trabajadores',
    type: 'section',
    icon: 'users',
    role: [Role.Developer, Role.Coordinator, Role.Employee],
    children: [
      {
        id: 'newWorker',
        title: 'Agregar Personal',
        icon: 'users',
        type: 'collapsible',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
        children: [
          {
            id: 'newWorkerInformation',
            title: '*Información',
            type: 'item',
            url: 'pages/app/worker/new/information',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'newOfficialWorker',
            title: 'Expediente Completo',
            type: 'item',
            url: 'pages/app/worker/new/official',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'newByClient',
            title: 'Por Obra',
            type: 'item',
            url: 'pages/app/worker/new/by-client',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'newSpecialWorker',
            title: 'Propietario',
            type: 'item',
            url: 'pages/app/worker/new/special',
            role: [Role.Developer, Role.Coordinator],
          },
          // {
          //   id: 'newTemporalWorker',
          //   title: 'Temporal',
          //   type: 'item',
          //   url: 'pages/app/worker/new/temporal',
          //   role: [Role.Developer, Role.Coordinator, Role.Employee],
          // },
        ],
      },
      {
        id: 'attendance',
        title: 'Asistencia',
        icon: 'clock',
        type: 'collapsible',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
        children: [
          {
            id: 'pendingOutcoming',
            title: 'Salidas Pendientes',
            type: 'item',
            url: 'pages/app/worker/pending-attendance',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
        ],
      },
      {
        id: 'search',
        title: 'Búsqueda',
        icon: 'search',
        type: 'collapsible',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
        children: [
          // {
          //   id: 'company',
          //   title: 'Compañía',
          //   type: 'item',
          //   url: 'pages/app/worker/search/company',
          //   role: [Role.Developer, Role.Coordinator, Role.Employee],
          // },
          {
            id: 'pending-scans',
            title: 'Escaneos Pendientes',
            type: 'item',
            url: 'pages/app/worker/search/pending-scan',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'pending-scans',
            title: 'Fotos Pendientes',
            type: 'item',
            url: 'pages/app/worker/search/pending-photo',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'fullName',
            title: 'Nombre completo',
            type: 'item',
            url: 'pages/app/worker/search/full-name',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'partialName',
            title: 'Parámetro del nombre',
            type: 'item',
            url: 'pages/app/worker/search/name',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
        ],
      },
      {
        id: 'credentials',
        title: 'Credenciales',
        icon: 'credit-card',
        type: 'collapsible',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
        children: [
          {
            id: 'credentials-list',
            title: 'Vista Previa',
            type: 'item',
            url: 'pages/app/worker/credentials/print-queue',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
        ]
      },
      {
        id: 'infraction',
        title: 'Infracciones',
        icon: 'clipboard',
        type: 'collapsible',
        role: [Role.Developer, Role.Coordinator, Role.Employee],
        children: [
          {
            id: 'areAnyActive',
            title: 'Activa',
            type: 'item',
            url: 'pages/app/infraction/search/curp',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'suspend',
            title: 'Suspensión',
            type: 'item',
            url: 'pages/app/infraction/search/suspend',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
          {
            id: 'ban',
            title: 'Veto',
            type: 'item',
            url: 'pages/app/infraction/search/ban',
            role: [Role.Developer, Role.Coordinator, Role.Employee],
          },
        ],
      },
    ],
  },
];
